<!--NEW CONTACT SALES-->
<app-hero-banner
  *ngIf="contactSalesForm"
  [id]="id"
  [heroImageCss]="heroImageCss"
  [displayCss]="displayCss"
  [alignContentCss]="alignContentCss"
  [showButton]="showButton">
  <div content class="equal-width-column margin-right-large">
    <app-eloqua-form [formType]="formType" [redirectUrl]="redirectUrl"></app-eloqua-form>
  </div>
</app-hero-banner>
<!--END CONTACT SALES-->

<!--OLD CONTACT SALES-->
<app-hero-banner
  *ngIf="!contactSalesForm"
  [id]="id"
  [name]="name"
  [title]="title"
  [description]="description"
  [heroImageCss]="heroImageCss"
  [displayCss]="displayCss"
  [alignContentCss]="alignContentCss"
  [showButton]="showButton">
  <div content class="right-aside-column">
    <app-eloqua-form [formType]="formType" [redirectUrl]="redirectUrl"></app-eloqua-form>
  </div>
</app-hero-banner>
<!--END CONTACT SALES-->

<!-- We can always leverage this modal content if we want to have a different message text for each contact us form in future -->
<!--THANKYOU MESSAGE SUCCESS MODAL-->
<app-modal-dialog
  [containerID]="'eloqSuccessQuoteModal'"
  [modalMaxWidth]="'modal-max-width-small'"
  (sendClick)="resetForm($event)">
  <div #modalContainer>
    <h4 class="text-align-center margin-bottom-large">Thank you for your interest!</h4>
    <p class="text-align-center">
      One of our educational advisors will contact you soon with further details.
    </p>
  </div>
</app-modal-dialog>
<!--END THANKYOU MESSAGE SUCCESS MODAL-->
